import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "../../axios";
import Loading from "../../hoc/Loading/Loading";
import * as actionCreators from "../../modules/actions/index";
import { isMobile } from "../../utils/deviceInfo";
import * as url from "../../utils/url";
import "./trivia-survey.css";
import "./trivia-breaking-news.css";
import { Spinner } from "../../utils/constants";

import BottomScrollListener from "react-bottom-scroll-listener";
import EmptyTable from "../../components/EmptyTable/EmptyTable";

class TriviaBreakingNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breakingNewsList: [],
      hoveredNews: null,
      currentPage: 1,
      loading: true,
    };
  }
  componentDidMount() {
    if (isMobile) {
      this.props.updateNavBar({
        title: "Trivvy",
        hasBack: true,
        backButton: "<b>Back</b>",
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
      });
    }
    this.retrieveBreakingNews(1);
  }

  handleBottomScroll = () => {
    const { TriviaBreakingNews } = this.props;
    const totalPages =
      TriviaBreakingNews &&
      TriviaBreakingNews.meta &&
      TriviaBreakingNews.meta.pagination &&
      TriviaBreakingNews.meta.pagination.totalPages
        ? TriviaBreakingNews.meta.pagination.totalPages
        : 0;
    if (
      totalPages > this.state.currentPage
    ) {
      this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }), () => {
        this.retrieveBreakingNews(this.state.currentPage);
      });
    }
  };

  truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength).trim() + '…' : text;
  }

  retrieveBreakingNews = (page) => {
    this.setState({
      loading: true,
    })
    axios
      .get(url.getTriviaBreakingNewsList, { params: { page, limit: 20 } })
      .then(({ data }) => {
        this.props.setTriviaBreakingNewsList(data);

        if (data.data.length > 0) {
          this.setState({
            breakingNewsList: [...this.state.breakingNewsList, ...data.data],
            loading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        })
      });
  };

  render() {
    const { breakingNewsList, loading } = this.state;

    return (
      <div id="triviaListPage">
        {loading && (
          <img
            src={Spinner}
            className="spinner-pos news-loading"
            alt="Loading..."
          />
        )}
        <div className={loading ? "wrapped-component-on-loading" : ""}>
        {breakingNewsList.length === -1 ? (
          <div className="d-flex justify-content-center">
            <EmptyTable
              title={"No News found"}
              subtitle={"Please check later"}
            />
          </div>
        ) : (
          <div>
            {!isMobile ? (
              <div className="news-cards-wrapper trivia_survey_list_table">
                <BottomScrollListener
                  debounce={200}
                  onBottom={this.handleBottomScroll}
                >
                  {(scrollRef) => (
                    <div
                      ref={scrollRef}
                      className="news-card-container trivia_survey_list_table_contents_scroll"
                    >
                      {breakingNewsList.map((item, idx) => (
                        <div
                          key={idx}
                          className="news-card d-flex mb-4"
                          onClick={() => window.open(item.url, "_blank")}
                          onMouseEnter={() =>
                            this.setState({ hoveredNews: item._id })
                          }
                          onMouseLeave={() =>
                            this.setState({ hoveredNews: null })
                          }
                        >
                          {/* Image */}
                          <div className="news-card-image">
                            <img
                              className="news-card-img"
                              src={item.image}
                              alt="Meta"
                            />
                          </div>

                          {/* Content */}
                          <div
                            className="d-flex flex-column justify-content-between news-card-content"
                          >
                            <div>
                              <div className="text-danger font-weight-bold mb-1">
                                {moment(item.fetchDate).format("MMMM D, YYYY")}
                              </div>
                              <h6 className="font-weight-bold mb-2 line-clamp-1">
                                {item.title || ''}
                              </h6>
                              <p className="mb-0 news-card-summary">
                                {this.truncateText(item.articleSummary, 335) || ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </BottomScrollListener>
              </div>
            ) : (
              <div className="news-cards-wrapper trivia_survey_list_table">
                <BottomScrollListener
                  offset={100}
                  onBottom={this.handleBottomScroll}
                >
                  {(scrollRef) => (
                    <div
                      ref={scrollRef}
                      className="news-card-container news-card-container-mobile trivia_survey_list_table_contents_scroll"
                    >
                      {breakingNewsList.map((item, idx) => (
                        <div
                          key={idx}
                          className="news-card d-flex flex-column flex-md-row mb-4 news-card-mobile-box-shadow"
                          onClick={() => window.open(item.url, "_blank")}
                          onMouseEnter={() =>
                            this.setState({ hoveredNews: item._id })
                          }
                          onMouseLeave={() =>
                            this.setState({ hoveredNews: null })
                          }
                        >
                          {/* Image Section */}
                          <div
                            className="w-100 w-md-auto news-card-image-mobile"
                          >
                            <img
                              src={item.image}
                              alt="Meta"
                              className="img-fluid w-100 news-card-img-mobile"
                            />
                          </div>

                          {/* Content Section */}
                          <div
                            className="p-3 d-flex flex-column justify-content-between news-card-content-mobile"
                          >
                            <div>
                              <div className="text-danger fw-bold mb-1">
                                {moment(item.fetchDate).format("MMMM D, YYYY")}
                              </div>
                              <h6 className="fw-bold mb-2 line-clamp-2">{item.title}</h6>
                              <p className="mb-0 news-card-summary">
                              {this.truncateText(item.articleSummary, 335) || ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </BottomScrollListener>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    TriviaBreakingNews: state.trivia.TriviaBreakingNews,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    setTriviaBreakingNewsList: (data) =>
      dispatch(actionCreators.setTriviaBreakingNewsList(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaBreakingNews, axios));
